<template>
    <div class="layout-wrapper">
        <div class="container-fluid">
            <div class="col-12">
                <div class="card shadow">
                    <div class="card-header  bg-accent-grad glow-accent text-center">
                        <h3 class="text-white">مدیریت قراردادهای مشتریان</h3>

                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="card-header admin-header w-100">

                                <h5 class="text-accent-light">قرارداد مشتری ها</h5>
                                <!--<h5 class="text-accent-light" v-if="showReciveDate">(سر رسید تاریخ)</h5>-->
                                <h5 class="text-accent-light" v-if="showArchive">(آرشیو شده)</h5>
                                <div class="text-left">
                                    <button class="btn btn-link text-accent-lightt"
                                            @click="onArchiveClicked()">
                                        <i class="fa fa-eye" v-if="showArchive" title="عدم نمایش آرشیو ها"></i>
                                        <i class="fa fa-eye-slash" v-else title="نمایش آرشیو ها"></i>
                                    </button>
                                    <!--<button class="btn btn-link text-accent-light"-->
                                    <!--@click="onReciveDateClicked()">-->
                                    <!--<i class="fa fa-calendar-check-o" v-if="showReciveDate"-->
                                    <!--title="عدم نمایش سررسیدها"></i>-->
                                    <!--<i class="fa fa-calendar-times-o" v-else title="نمایش سررسیدها"></i>-->
                                    <!--</button>-->

                                    <button class="btn btn-link text-accent-light"
                                            @click="onAddcustomerBuyClicked()"><i class="fa fa-plus"></i>
                                    </button>
                                </div>
                            </div>

                            <div class="col-12 input-group round mb-3" v-if="!showArchive">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">جستجو</span>
                                </div>
                                <input class="form-control" v-model="search" @input="searching()"
                                       placeholder="حداقل 2 کاراکتر از نام یا نام خانوادگی یا شماره موبایل یا محصول را وارد کنید">
                            </div>
                            <div class="table-responsive">
                                <div v-if="!isLoading">
                                    <preloader/>
                                </div>
                                <div v-else>
                                    <div v-if="mycustomerBuys.length===0">
                                        <p class="text-center mt-3">هیچ قراردادی ثبت نشده است. برای ثبت روی دکمه + کلیک
                                            کنید</p>

                                    </div>
                                    <div v-else>
                                        <table class="table table-hover table-striped mb-3">
                                            <thead>
                                            <tr>
                                                <th>نام مشتری</th>
                                                <th>نام محصول</th>
                                                <!--<th>بازاریاب</th>-->
                                                <!--<th>معرف</th>-->
                                                <!--<th>پشتیبان</th>-->
                                                <th>مبلغ قرارداد</th>
                                                <!--<th>شروع قرارداد</th>-->
                                                <th>مانده</th>
                                                <th>دریافتها</th>
                                                <th>پایان قرارداد</th>
                                                <!--<th v-if="accountPanel">پرداختها</th>-->
                                                <th class="text-center">عملیات</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            <tr v-for="it in mycustomerBuys">

                                                <td class="text-nowrap">{{it.customer.fullName}}</td>
                                                <td class="text-nowrap">{{it.product.name}}</td>
                                                <!--<td class="text-nowrap">{{it.bazaryab === null || it.bazaryab ===-->
                                                <!--undefined ? '' : it.bazaryab.fullName}}-->
                                                <!--</td>-->
                                                <!--<td class="text-nowrap">{{it.moaref === null || it.moaref === undefined-->
                                                <!--? '' : it.moaref.fullName}}-->
                                                <!--</td>-->
                                                <!--<td class="text-nowrap">{{it.backup === null || it.backup === undefined-->
                                                <!--? '' : it.backup.fullName}}-->
                                                <!--</td>-->
                                                <td class="text-nowrap">{{it.price.toLocaleString() }}</td>
                                                <!--<td class="text-nowrap">{{it.fstartDate}}</td>-->
                                                <td class="text-nowrap">{{it.remain.toLocaleString()
                                                    }}
                                                </td>
                                                <td><i class="fa fa-eye px-3 clickable"
                                                       style="font-size: larger"
                                                       @click="seeRecItem(it)"
                                                       title="مشاهده دریافت">
                                                </i>
                                                </td>
                                                <td class="text-nowrap">{{it.fendDate}}</td>
                                                <!--<td v-if="accountPanel"><i class="fa fa-eye px-3 clickable"-->
                                                <!--style="font-size: larger"-->
                                                <!--@click="seeItem(it)"-->
                                                <!--title="مشاهده پرداختها"></i></td>-->
                                                <td class="text-center text-nowrap"><i
                                                        class="fa fa-percent px-3 clickable"
                                                        style="font-size: larger"
                                                        @click="percentItem(it)"
                                                        title="درصدهای قرارداد"></i>
                                                    |
                                                    <a :href="validateDownloadImageUrl(it.documents === null ?'': it.documents.address)"
                                                       target="_blank"
                                                       download
                                                       style="color: inherit !important;">
                                                        <i class="fa fa-image px-3 clickable"
                                                           style="font-size: larger"
                                                           v-if="it.documentsId !=null"
                                                           title="دانلود تصویر"></i>
                                                    </a>
                                                    | <i
                                                            class="fa fa-pencil-square-o px-3 clickable"
                                                            style="font-size: larger"
                                                            @click="editItem(it)"
                                                            title="ویرایش آیتم"></i>
                                                    | <i class="fa fa-trash-o px-3 clickable"
                                                         style="font-size: larger"
                                                         @click="deleteItem(it)"
                                                         title="حذف آیتم"></i>
                                                </td>

                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!--///////////////////////////////////////////////////////////////////////////////////////////////////-->
            <modal show="false" ref="insertModal">
                <div class="row p-3">
                    <div class="col-12 text-center">
                        <h1 v-if="customerBuyMode === 'create'">ثبت قرارداد</h1>
                        <h3 v-else> ویرایش قرارداد (اگر پرداخت ثبت کرده باشید قیمت و درصدها ثبت نمیشوند)</h3>
                    </div>

                    <div class="row w-100 mt-3 p-5" v-if="customerBuyMode === 'create'">
                        <div class="col-12 input-group round mb-3">
                            <div class="input-group-prepend">
                                <span class="input-group-text">جستجو</span>
                            </div>
                            <input class="form-control" v-model="searchcustomer" @input="searchingcustomer()"
                                   placeholder="حداقل 2 کاراکتر از نام یا نام خانوادگی یا شماره موبایل را وارد کنید">
                        </div>
                        <div class="col-12 overflow-auto" style="max-height: 12rem;">
                            <table class="table table-hover table-striped ">
                                <thead>
                                <tr>
                                    <th>نام مشتری</th>
                                    <th>کد مشتری</th>
                                    <th>موبایل</th>
                                    <th>انتخاب</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="it in customers">

                                    <td class="clickable" @click="selectItem(it)">{{it.fullName}}</td>
                                    <td>{{it.fatherName}}</td>
                                    <td>{{it.mobile}}</td>
                                    <td class="text-center"><i class="fa fa-hand-o-up px-3 clickable"
                                                               style="font-size: larger"
                                                               @click="selectItem(it)"
                                                               title="انتخاب آیتم"></i>
                                    </td>

                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <hr class="w-100"/>
                    <h5 class="col-12 text-center"> مشتری انتخاب شده</h5>
                    <div class="row w-100 p-3">
                        <div class="col-lg-4 mb-4">
                            <div class="input-group round">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">نام مشتری</span>
                                </div>
                                <input class="form-control" readonly="true" v-model="customerName">
                            </div>
                        </div>
                        <div class="col-lg-4 mb-4">
                            <div class="input-group round">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">کد مشتری</span>
                                </div>
                                <input class="form-control" readonly="true" v-model="customerFather">
                            </div>
                        </div>
                        <div class="col-lg-4 mb-4">
                            <div class="input-group round">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">موبایل</span>
                                </div>
                                <input class="form-control" readonly="true" v-model="customerMobile">
                            </div>
                        </div>
                    </div>
                    <hr class="w-100"/>
                    <div class="row w-100 p-3">
                        <div class="col-lg-3 mb-2">
                            <div class="input-group round">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">محصول</span>
                                </div>
                                <vs-select @onSearch="onDropDownFocused" @onSearchBlurred="onDropDownBlurred"
                                           ref="evidence"
                                           :data="products"
                                           :mode="'create'"
                                           :selected-val="selectedproduct"
                                           :header="{multiple: false, label: 'name'}"
                                           aria-placeholder="محصول"
                                           @onChange="onproductChange"></vs-select>
                            </div>
                        </div>
                        <div class="col-lg-3 mb-2">
                            <div class="input-group round text-center d-block">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">مبلغ قرارداد</span>
                                    <input type="number" class="form-control" v-model="customerBuyModel.price"
                                           @input="thousandSeprator">
                                </div>
                                <small class="text-left">{{customerBuyModel.showprice}}</small>
                            </div>
                        </div>
                        <div class="col-lg-3 mb-2">
                            <div class="input-group round">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">تاریخ شروع قرارداد</span>
                                </div>
                                <date-picker type="date" format="jYYYY/jMM/jDD" @input="onCreateDatePicked"
                                             :auto-submit="true"
                                             ref="startDate" style="flex: 1">
                                    <slot>
                                        <input v-model="newstartDate"
                                               class="form-control date-input flex-grow-1" readonly="true"
                                               @click="toggleCreateDatePicker">
                                    </slot>
                                </date-picker>
                            </div>
                        </div>
                        <div class="col-lg-3 mb-2">
                            <div class="input-group round">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">تاریخ پایان قرارداد</span>
                                </div>
                                <date-picker type="date" format="jYYYY/jMM/jDD" @input="onCreateendDatePicked"
                                             :auto-submit="true"
                                             ref="endDate" style="flex: 1">
                                    <slot>
                                        <input v-model="newendDate"
                                               class="form-control date-input flex-grow-1" readonly="true"
                                               @click="toggleCreateendDatePicker">
                                    </slot>
                                </date-picker>
                            </div>
                        </div>
                    </div>

                    <hr class="w-100"/>
                    <h5 class="col-12 text-center my-3">مشخصات سایت و سایر پنلها</h5>
                    <div class="row w-100 mb-3 p-3">
                        <div class="col-lg-4 mb-4">
                            <div class="input-group round">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">آدرس سایت</span>
                                </div>
                                <input class="form-control" v-model="customerBuyModel.siteAddress">
                            </div>
                        </div>
                        <div class="col-lg-4 mb-4">
                            <div class="input-group round">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">یوزر سایت</span>
                                </div>
                                <input class="form-control" v-model="customerBuyModel.siteUser">
                            </div>
                        </div>
                        <div class="col-lg-4 mb-4">
                            <div class="input-group round">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">پسورد سایت</span>
                                </div>
                                <input class="form-control" v-model="customerBuyModel.sitePass">
                            </div>
                        </div>
                        <div class="col-lg-4 mb-4">
                            <div class="input-group round">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">آدرس هاست</span>
                                </div>
                                <input class="form-control" v-model="customerBuyModel.hostAddress">
                            </div>
                        </div>
                        <div class="col-lg-4 mb-4">
                            <div class="input-group round">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">یوزر هاست</span>
                                </div>
                                <input class="form-control" v-model="customerBuyModel.hostUser">
                            </div>
                        </div>
                        <div class="col-lg-4 mb-4">
                            <div class="input-group round">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">پسورد هاست</span>
                                </div>
                                <input class="form-control" v-model="customerBuyModel.hostPass">
                            </div>
                        </div>

                        <div class="col-lg-4 mb-4">
                            <div class="input-group round">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">شماره پنل اسمس</span>
                                </div>
                                <input class="form-control" v-model="customerBuyModel.smsNumber">
                            </div>
                        </div>
                        <div class="col-lg-4 mb-4">
                            <div class="input-group round">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">یوزر پنل اسمس</span>
                                </div>
                                <input class="form-control" v-model="customerBuyModel.smsUser">
                            </div>
                        </div>
                        <div class="col-lg-4 mb-4">
                            <div class="input-group round">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">پسورد پنل اسمس</span>
                                </div>
                                <input class="form-control" v-model="customerBuyModel.smsPass">
                            </div>
                        </div>
                    </div>

                    <div class="col-12 text-center">
                        <div class="profile-image text-center">
                            <img :src="customerBuyModel.newImage" id="docImg" class="img-fluid"
                                 v-if="newImageCliked">
                            <img :src="validateImageUrl(customerBuyModel.documentsId === null ?'':customerBuyModel.documents.address)"
                                 class="img-fluid" v-else>
                            <span class="img-fluid d-flex justify-content-center" v-if="newImageCliked"> نوع فایل : {{customerBuyModel.ext}}</span>
                            <small class="d-flex justify-content-center">فقط فایلهای عکسی، تکسی، زیپ، پی دی اف قابل
                                بارگزاری هستند
                            </small>
                            <small> (jpg/jpeg/png/txt/doc/docx/zip/rar/pdf)</small>
                        </div>
                        <input type="file" id="fileUpload" class="d-none"
                               @change="onImageChange($event)">
                        <label for="fileUpload" class="btn btn-info btn-round mb-3 clickable">بارگذاری
                            فایل قرارداد</label>
                    </div>


                    <div class="col-12 text-center" v-if="customerBuyMode === 'edit'">
                        <hr/>
                        <div class="row">
                            <div class="col-4 mt-3"></div>
                            <div class="col-3 mt-3">
                                <h5>پایان قرارداد و آرشیو کردن اطلاعات</h5>
                            </div>
                            <div class="col-1 text-left  mt-3">
                                <toggle-button id="changed-font" class="m-0 ml-5"
                                               :color="{checked: '#297bf6', unchecked: '#90a4ae'}"
                                               :value="customerBuyModel.endConract"
                                               :sync="true" @change="onEndContractChange($event)"/>
                            </div>
                        </div>
                    </div>

                    <div class="col-lg-6 offset-lg-3 text-center">
                        <button class="btn btn-success btn-round clickable mt-3" :disabled="isSending"
                                @click="updatecustomerBuy" v-if="customerBuyMode=='edit'">ویرایش قرارداد
                        </button>
                        <button class="btn btn-success btn-round clickable mt-3" :disabled="isSending"
                                @click="createcustomerBuy" v-else>ثبت قرارداد
                        </button>
                        <button class="btn btn-primary btn-round clickable mt-3 mx-3"
                                @click="cancelcustomerBuy">انصراف
                        </button>
                    </div>

                </div>
            </modal>
            <modal show="false" ref="insertModal2">
                <div class="row p-3">
                    <div class="col-12 text-center">
                        <h1 v-if="customerBuyMode === 'create'">ثبت قرارداد</h1>
                        <h3 v-else> ویرایش درصدهای قرارداد (اگر پرداخت ثبت کرده باشید درصدها ثبت نمیشوند)</h3>
                    </div>


                    <h5 class="col-12 text-center">{{customerBuyFullname}}</h5>

                    <h5 class="col-12 text-center my-3">درصدهای ثابت از کل قرارداد</h5>

                    <div class="row p-3 mb-4">
                        <div class="col-lg-4 mb-2">
                            <div class="input-group round">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">بازاریاب</span>
                                </div>
                                <vs-select @onSearch="onDropDownFocused" @onSearchBlurred="onDropDownBlurred"
                                           ref="evidence"
                                           :data="users"
                                           :mode="'create'"
                                           :selected-val="selectedbazaryab"
                                           :header="{multiple: false, label: 'fullName'}"
                                           aria-placeholder="بازاریاب"
                                           @onChange="onbazaryabChange"></vs-select>
                            </div>
                        </div>

                        <div class="col-lg-4 mb-4">
                            <div class="input-group round">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">درصد بازاریاب</span>
                                </div>
                                <input type="number" class="form-control"
                                       v-model="customerBuyModel.bazaryabPercent">
                            </div>
                        </div>
                        <div class="col-lg-4 mb-4">
                            <div class="input-group round">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">درصد مدیر بازاریاب</span>
                                </div>
                                <input type="number" class="form-control" v-model="customerBuyModel.managerPercent">
                            </div>
                        </div>
                        <div class="col-lg-4 mb-2">
                            <div class="input-group round">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">پشتیبان</span>
                                </div>
                                <vs-select @onSearch="onDropDownFocused" @onSearchBlurred="onDropDownBlurred"
                                           ref="evidence"
                                           :data="users"
                                           :mode="'create'"
                                           :selected-val="selectedbackup"
                                           :header="{multiple: false, label: 'fullName'}"
                                           aria-placeholder="پشتیبان"
                                           @onChange="onbackupChange"></vs-select>
                            </div>
                        </div>

                        <div class="col-lg-4 mb-4">
                            <div class="input-group round">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">درصد پشتیبان</span>
                                </div>
                                <input type="number" class="form-control"
                                       v-model="customerBuyModel.backupPecent">
                            </div>
                        </div>
                        <div class="col-lg-4 mb-4">
                            <div class="input-group round">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">درصد سرپرست پشتیبان</span>
                                </div>
                                <input type="number" class="form-control"
                                       v-model="customerBuyModel.backupManagerPercent">
                            </div>
                        </div>
                        <div class="col-lg-4 mb-2">
                            <div class="input-group round">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">معرف</span>
                                </div>
                                <vs-select @onSearch="onDropDownFocused" @onSearchBlurred="onDropDownBlurred"
                                           ref="evidence"
                                           :data="users"
                                           :mode="'create'"
                                           :selected-val="selectedmoaref"
                                           :header="{multiple: false, label: 'fullName'}"
                                           aria-placeholder="سرپرست طراحی"
                                           @onChange="onmoarefChange"></vs-select>
                            </div>
                        </div>
                        <div class="col-lg-4 mb-4">
                            <div class="input-group round">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">درصد معرف</span>
                                </div>
                                <input type="number" class="form-control" v-model="customerBuyModel.moarefPecent">
                            </div>
                        </div>
                        <div class="col-lg-4 mb-4">
                            <div class="input-group round">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">درصد شرکت</span>
                                </div>
                                <input type="number" class="form-control" v-model="customerBuyModel.companyPercent">
                            </div>
                        </div>

                    </div>

                    <!--////////////////////////////////////////////////////////////////////////////////-->
                    <h5 class="col-12 text-center my-3">درصدهای تعریفی قرارداد</h5>
                    <div class="row w-100 mb-3 p-3">
                        <div class="row w-100" v-if="customerBuyMode !=='edit'">
                            <div class="col-lg-3 mb-2">
                                <div class="input-group round">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">عنوان</span>
                                    </div>
                                    <vs-select @onSearch="onDropDownFocused" @onSearchBlurred="onDropDownBlurred"
                                               ref="evidence"
                                               :data="percents"
                                               :mode="'create'"
                                               :selected-val="selectedpercents"
                                               :header="{multiple: false, label: 'fullName'}"
                                               aria-placeholder="عنوان"
                                               @onChange="onPercentsChange"></vs-select>
                                </div>
                            </div>
                            <div class="col-lg-3 mb-2">
                                <div class="input-group round text-center d-block">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">مقدار درصد</span>
                                        <input type="number" class="form-control" v-model="buyPercentsModel.value">
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-4 mb-2" v-if="selectedpercents.userDependency">
                                <div class="input-group round">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">انتخاب کاربر</span>
                                    </div>
                                    <vs-select @onSearch="onDropDownFocused" @onSearchBlurred="onDropDownBlurred"
                                               ref="evidence"
                                               :data="users"
                                               :mode="'create'"
                                               :selected-val="selectedUserDependency"
                                               :header="{multiple: false, label: 'fullName'}"
                                               aria-placeholder="بازاریاب"
                                               @onChange="onuserDependencyChange"></vs-select>
                                </div>
                            </div>
                            <div class="col-lg-2 mb-2 text-center">
                                <button class="btn btn-success btn-round clickable"
                                        @click="addBuyPercent">افزودن درصد
                                </button>
                            </div>
                        </div>


                        <hr/>
                        <div class="col-lg-12 mb-2" v-if="buyPercents.length===0">
                            <p class="text-center mt-3">هیچ درصدی برای قراردادها ثبت نشده است.</p>

                        </div>
                        <div class="col-lg-12 mb-2" v-else>
                            <table class="table table-hover table-striped mb-3">
                                <thead>
                                <tr>
                                    <th>عنوان</th>
                                    <th>درصد از</th>
                                    <th>مقدار</th>
                                    <th>کاربر</th>

                                    <th class="text-center">عملیات</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="(it,index) in buyPercents">

                                    <td class="text-nowrap">{{it.name}}</td>
                                    <td class="text-nowrap">{{it.enpercentsName}}</td>
                                    <td class="text-nowrap">{{it.value}}</td>
                                    <td class="text-nowrap">{{it.fullName}}</td>

                                    <td class="text-center text-nowrap"><i class="fa fa-trash-o px-3 clickable"
                                                                           style="font-size: larger"
                                                                           @click="deleteBuyPercentsItem(it,index)"
                                                                           title="حذف آیتم"></i>
                                    </td>

                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <!--////////////////////////////////////////////////////////////////////////////////-->


                    <div class="col-lg-6 offset-lg-3 text-center">
                        <button class="btn btn-success btn-round clickable mt-3" :disabled="isSending"
                                @click="updatecustomerBuyPercent">ویرایش درصدهای قرارداد
                        </button>

                        <button class="btn btn-primary btn-round clickable mt-3 mx-3"
                                @click="cancelcustomerBuy">انصراف
                        </button>
                    </div>

                </div>
            </modal>
        </div>
    </div>
</template>

<script>
    import BaseService from "../../_framework/api/BaseService";
    import DatePicker from '../../_framework/vue-persian-datetime-picker/VuePersianDatetimePicker.vue';
    import VsSelect from "../../_framework/VsSelect";
    import Utils from "../../_framework/utils/Utils";
    import Moment from 'moment-jalali';
    import Constants from "../../_framework/Constants";

    export default {
        name: "customerBuy",
        components: {VsSelect, DatePicker},
        data() {
            return {

                isLoading: false,
                newImageCliked: false,
                mycustomerBuys: [],

                customerBuyMode: "",
                customerBuyModel: {
                    documents: {
                        address: "",
                        extension: ""
                    },
                    id: 0,
                    price: 0,
                    customerId: 0,
                    productId: 0,

                    startDate: "",
                    endDate: "",

                    moarefId: 0,
                    moarefPecent: 0,
                    backupId: 0,
                    backupPecent: 0,
                    backupManagerPercent: 0,
                    bazaryabId: 0,
                    bazaryabPercent: 0,
                    managerPercent: 0,
                    companyPercent: 0,

                    siteAddress: "",
                    siteUser: "",
                    sitePass: "",
                    hostAddress: "",
                    hostUser: "",
                    hostPass: "",
                    smsNumber: "",
                    smsUser: "",
                    smsPass: "",
                    endConract: false,
                },
                newstartDate: "",
                newendDate: "",
                search: "",
                customers: [],
                customerName: "",
                customerFather: "",
                customerMobile: "",
                customerId: 0,
                searchcustomer: "",
                showArchive: false,
                showReciveDate: false,
                isSending: false,
                accountPanel: false,
                selectedbazaryab: {},
                selectedmoaref: {},
                users: [],
                products: [],
                selectedproduct: {},
                selectedbackup: {},
                buyPercents: [],
                buyPercentsModel: {
                    percentsId: 0,
                    customerBuyId: 0,
                    userId: 0,
                    value: 0,
                    enpercentsName: "",
                    fullName: "",
                },
                percents: [],
                enpercents: [],
                selectedenpercents: {},
                selectedpercents: {},
                selectedUserDependency: {},
                customerBuyId: 0,
                customerBuyFullname: "",
                pSending: false,

            }
        },
        mounted() {
            this.accountPanel = this.userId = Constants.ACCOUNTING_PANEL;
            // console.log("dsadsasddsa")
            if (this.$route.params.param === 'true') {
                this.onReciveDateClicked();
            } else {
                this.getMycustomerBuys();
            }
            this.getUsers();
            this.getproducts();
            this.getEnPercents();
            // this.getPercents();
        },
        methods: {
            getUsers() {
                new BaseService("user", "/GetUser").getList().then(response => {
                    this.users = response.data;
                    for (let it of this.users) {
                        it.fullName = it.fullName + " || " + it.enRoleName;
                    }
                }).catch(error => {
                    // console.log(error);
                    Utils.handleErrorWithNotification(error.data, this.$noty);
                });
            },
            getproducts() {
                new BaseService("product", "/Getproduct").getList().then(response => {
                    this.products = response.data;
                    // for (let it of this.devices) {
                    //     it.title = it.deviceName + " کد:" + it.deviceCode;
                    // }
                }).catch(error => {
                    // console.log(error);
                    Utils.handleErrorWithNotification(error.data, this.$noty);
                });
            },
            getPercents() {
                new BaseService("percents", "/Getpercents").getList().then(response => {
                    this.percents = response.data;
                    for (let it of this.percents) {
                        for (let j of this.enpercents) {
                            if (j.value === it.enPercents) {
                                it.fullName = it.name + " / " + j.title;
                            }
                        }
                    }
                    console.log(this.percents)
                }).catch(error => {
                    // console.log(error);
                    Utils.handleErrorWithNotification(error.data, this.$noty);
                });
            },
            getEnPercents() {
                new BaseService("Enum", "/GetEnpercents").getList().then(response => {
                    this.enpercents = response.data;
                    this.getPercents();
                }).catch(error => {
                    // console.log(error);
                    Utils.handleErrorWithNotification(error.data, this.$noty);
                });
            },


            onArchiveClicked() {
                if (this.showArchive) {
                    this.showArchive = false;
                    this.getMycustomerBuys();
                } else {
                    this.showArchive = true;
                    new BaseService("customerBuy", "/GetArchivecustomerBuy").getList().then(response => {
                        this.mycustomerBuys = response.data;
                        for (let it of this.mycustomerBuys) {
                            it.fstartDate = Moment(this.gregorianToJalali(it.startDate), 'jYYYY/jMM/jDD').format('jDD jMMMM jYYYY');
                            it.fendDate = Moment(this.gregorianToJalali(it.endDate), 'jYYYY/jMM/jDD').format('jDD jMMMM jYYYY');
                        }
                        this.isLoading = true;
                    }).catch(error => {
                        Utils.handleErrorWithNotification(error.data, this.$noty);
                    });
                }
            },
            onReciveDateClicked() {
                if (this.showReciveDate === true) {
                    this.showReciveDate = false;
                    this.getMycustomerBuys();
                } else {
                    this.showReciveDate = true;
                    this.newImageCliked = false;
                    new BaseService("customerBuy", "/GetRemainCustomerBuy").getList().then(response => {
                        this.mycustomerBuys = response.data;
                        for (let it of this.mycustomerBuys) {
                            it.fstartDate = Moment(this.gregorianToJalali(it.startDate), 'jYYYY/jMM/jDD').format('jDD jMMMM jYYYY');
                            it.fendDate = Moment(this.gregorianToJalali(it.endDate), 'jYYYY/jMM/jDD').format('jDD jMMMM jYYYY');
                        }
                        this.isLoading = true;
                    }).catch(error => {
                        Utils.handleErrorWithNotification(error.data, this.$noty);
                    });
                }
            },

            getcustomers() {
                new BaseService("customer", "/Getcustomer").getList().then(response => {
                    this.customers = response.data;
                }).catch(error => {
                    console.log(error);
                    Utils.handleErrorWithNotification(error.data, this.$noty);
                });
            },

            onAddcustomerBuyClicked() {
                this.customerBuyModel = {
                    id: 0,
                    price: "",
                    customerId: 0,
                    documents: {
                        address: "",
                        extension: ""
                    },
                    startDate: "2020-11-13T14:51:43.919Z",
                    endDate: "2020-11-13T14:51:43.919Z",
                };
                this.customerName = "";
                this.customerFather = "";
                this.customerMobile = "";
                this.customerId = 0;
                this.getcustomers();
                this.newstartDate = "";
                this.newendDate = "";
                this.selectedbazaryab = {};
                this.selectedmoaref = {};
                this.selectedproduct = {};
                this.selectedbackup = {};
                this.buyPercents = [];
                this.buyPercentsModel = {
                    percentsId: 0,
                    customerBuyId: 0,
                    userId: 0,
                    value: 0,
                    enpercentsName: "",
                    fullName: "",
                };
                this.customerBuyMode = "create";
                this.$refs.insertModal.showModal();
            },
            getMycustomerBuys() {
                this.showReciveDate = false;
                this.showArchive = false;
                new BaseService("customerBuy", "/GetcustomerBuy").getList().then(response => {
                    this.mycustomerBuys = response.data;
                    for (let it of this.mycustomerBuys) {
                        it.fstartDate = Moment(this.gregorianToJalali(it.startDate), 'jYYYY/jMM/jDD').format('jDD jMMMM jYYYY');
                        it.fendDate = Moment(this.gregorianToJalali(it.endDate), 'jYYYY/jMM/jDD').format('jDD jMMMM jYYYY');
                    }
                    this.isLoading = true;
                }).catch(error => {
                    Utils.handleErrorWithNotification(error.data, this.$noty);
                });
            },
            percentItem(item) {
                this.customerBuyId = item.id;
                this.customerBuyFullname = "قرارداد " + item.customer.fullName + " محصول " + item.product.name;
                this.customerBuyModel = item;
                console.log(this.users)
                for (let i of this.users) {
                    if (i.id === item.bazaryabId) {
                        this.selectedbazaryab = i;
                        console.log(this.selectedbazaryab)
                    }
                    if (i.id === item.moarefId) {
                        this.selectedmoaref = i;
                        console.log(this.selectedmoaref)
                    }
                }
                new BaseService("BuyPercents", `/GetPercentsByCustomerBuyId/${this.customerBuyId}`).getList().then(response => {
                    this.buyPercents = response.data;
                    console.log(this.buyPercents)
                    for (let it of this.buyPercents) {
                        for (let j of this.enpercents) {
                            if (j.value === it.percents.enPercents) {
                                it.enpercentsName = j.title;
                            }
                        }
                        it.fullName = "";
                        if (it.userId != null) {
                            it.fullName = it.user.fullName;
                        }
                        it.name = it.percents.name;
                    }
                    this.isLoading = true;
                }).catch(error => {
                    console.log(error)
                    Utils.handleErrorWithNotification(error.data, this.$noty);
                });


                this.$refs.insertModal2.showModal();
            },
            editItem(item) {
                this.newImageCliked = false;
                this.customerBuyModel = item;
                this.customerBuyMode = "edit";
                if (item.startDate != null) {
                    this.newstartDate = Moment(this.gregorianToJalali(item.startDate), 'jYYYY/jMM/jDD').format('jDD jMMMM jYYYY');
                }
                if (item.endDate != null) {
                    this.newendDate = Moment(this.gregorianToJalali(item.endDate), 'jYYYY/jMM/jDD').format('jDD jMMMM jYYYY');
                }
                for (let i of this.products) {
                    if (i.id === item.productId) {
                        this.selectedproduct = i;
                    }
                }
                console.log(this.customerBuyModel)
                for (let i of this.users) {
                    if (i.id === item.bazaryabId) {
                        this.selectedbazaryab = i;
                        console.log(this.selectedbazaryab)
                    }
                    if (i.id === item.moarefId) {
                        this.selectedmoaref = i;
                        console.log(this.selectedmoaref)
                    }
                }
                this.customerName = item.customer.fullName;
                this.customerFather = item.customer.fatherName;
                this.customerMobile = item.customer.mobile;
                this.$refs.insertModal.showModal();
            },
            deleteItem(item) {
                if (confirm("آیا از حذف این آیتم اطمینان دارید؟")) {
                    new BaseService("customerBuy", "DeletecustomerBuy").delete(item.id).then(response => {
                        this.$noty.warning("آیتم با موفقیت حذف شد");
                        this.getMycustomerBuys();
                    }).catch(error => {
                        Utils.handleErrorWithNotification("این آیتم در جای دیگری استفاده شده است، ابتدا موارد وابسته را پاک کنید", this.$noty);
                    })
                }
            },

            updatecustomerBuy() {
                this.isSending = true;
                console.log(this.customerBuyModel)
                new BaseService("customerBuy", "/UpdatecustomerBuy").update(this.customerBuyModel).then(response => {
                    this.$noty.success("قرارداد با موفقیت ویرایش شد");
                    this.isSending = false;
                    this.$refs.insertModal.hideModal();
                    this.getMycustomerBuys();
                }).catch(error => {
                    this.isSending = false;
                    Utils.handleErrorWithNotification(error.data, this.$noty);
                    this.$refs.insertModal.hideModal();
                    this.getMycustomerBuys();
                });
                this.selectedproduct = {};
                this.selectedbazaryab = {};
                this.selectedmoaref = {};
            },
            updatecustomerBuyPercent() {
                this.isSending = true;
                new BaseService("customerBuy", "/UpdatecustomerBuy").update(this.customerBuyModel).then(response => {
                    this.$noty.success("درصدهای قرارداد با موفقیت ویرایش شد");
                    this.isSending = false;
                    this.$refs.insertModal2.hideModal();
                    this.getMycustomerBuys();
                }).catch(error => {
                    this.isSending = false;
                    Utils.handleErrorWithNotification(error.data, this.$noty);
                    this.$refs.insertModal2.hideModal();
                    this.getMycustomerBuys();
                });

            },
            createcustomerBuy() {
                this.isSending = true;
                if (this.customerId == 0) {
                    Utils.handleErrorWithNotification("یک مشتری انتخاب کنید", this.$noty);
                    this.isSending = false;
                } else {
                    this.customerBuyModel.customerId = this.customerId;
                    console.log(this.customerBuyModel)
                    new BaseService("customerBuy", "/CreatecustomerBuy").create(this.customerBuyModel).then(response => {
                        this.$noty.success("قرارداد با موفقیت ثبت شد");
                        console.log(response.data);

                        this.isSending = false;
                        this.$refs.insertModal.hideModal();
                        this.getMycustomerBuys();
                    }).catch(error => {
                        this.isSending = false;
                        Utils.handleErrorWithNotification(error.data, this.$noty);
                        this.$refs.insertModal.hideModal();
                        this.getMycustomerBuys();
                    });
                }
            },
            cancelcustomerBuy() {
                this.$refs.insertModal.hideModal();
                this.$refs.insertModal2.hideModal();
                this.getMycustomerBuys();
            },
            onCreateDatePicked(val) {
                this.newstartDate = Moment(val, 'jYYYY/jMM/jDD').format('jDD jMMMM jYYYY');
                this.customerBuyModel.startDate = this.jalaliToGregorian(val);
                /* let startDate = this.startPersianDate.split("/");
                 console.log(startDate);*/
            },
            toggleCreateDatePicker() {
                this.$refs.startDate.togglePicker();
            },
            onCreateendDatePicked(val) {
                this.newendDate = Moment(val, 'jYYYY/jMM/jDD').format('jDD jMMMM jYYYY');
                this.customerBuyModel.endDate = this.jalaliToGregorian(val);
                /* let startDate = this.startPersianDate.split("/");
                 console.log(startDate);*/
            },
            toggleCreateendDatePicker() {
                this.$refs.endDate.togglePicker();
            },
            onProfileGenderChange(val) {
                if (val) {
                    this.customerBuyModel.male = val.value;
                }
            },


            searching() {
                if (this.search.length > 2) {
                    this.isLoading = false;
                    new BaseService("customerBuy", `/SearchcustomerBuy/${this.search}`).getList().then(response => {
                        this.mycustomerBuys = response.data;
                        for (let it of this.mycustomerBuys) {
                            it.fstartDate = Moment(this.gregorianToJalali(it.startDate), 'jYYYY/jMM/jDD').format('jDD jMMMM jYYYY');
                            it.fendDate = Moment(this.gregorianToJalali(it.endDate), 'jYYYY/jMM/jDD').format('jDD jMMMM jYYYY');
                        }
                        this.isLoading = true;
                    }).catch(error => {
                        Utils.handleErrorWithNotification(error.data, this.$noty);
                    });
                } else {
                    this.getMycustomerBuys();
                }
            },
            searchingcustomer() {
                if (this.searchcustomer.length > 2) {
                    new BaseService("customer", `/Searchcustomer/${this.searchcustomer}`).getList().then(response => {
                        this.customers = response.data;
                    }).catch(error => {
                        Utils.handleErrorWithNotification(error.data, this.$noty);
                    });
                } else {
                    this.getcustomers();
                }
            },
            selectItem(it) {
                this.customerName = it.fullName;
                this.customerFather = it.fatherName;
                this.customerMobile = it.mobile;
                this.customerId = it.id;

            },
            seeItem(it) {
                this.$router.push({
                    name: 'payments',
                    params: {
                        search: it.name
                    }
                });
            },
            seeRecItem(it) {
                this.$router.push({
                    name: 'recipts',
                    params: {
                        search: it.id
                    }
                });
            },
            thousandSeprator(a) {
                let amount = this.customerBuyModel.price;
                if (amount !== '' || amount !== undefined || amount !== 0 || amount !== '0' || amount !== null) {
                    this.customerBuyModel.showprice = amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                } else {
                    this.customerBuyModel.showprice = amount;
                }
            },
            onEndContractChange(e) {
                const m = {
                    contractId: this.customerBuyModel.id,
                    ending: e.value
                };
                new BaseService("customerBuy", '/EndcustomerBuy').update(m).then(response => {
                    if (e.value) {
                        this.$noty.success("قرارداد با موفقیت آرشیو شد و دیگر نشان داده نمیشود");

                    } else {
                        this.$noty.success("قرارداد با موفقیت بازیابی شد و نشان داده میشود");
                    }
                }).catch(error => {
                    Utils.handleErrorWithNotification(error.data, this.$noty);
                });
                this.customerBuyModel.endConract = e.value;

            },

            onbazaryabChange(val) {

                if (val && val.id) {
                    console.log(val)
                    this.customerBuyModel.bazaryabId = val.id;
                    this.selectedbazaryab = val;
                }
            },
            onbackupChange(val) {

                if (val && val.id) {
                    console.log(val)
                    this.customerBuyModel.backupId = val.id;
                    this.selectedbackup = val;
                }
            },
            onmoarefChange(val) {
                if (val && val.id) {
                    console.log(val)
                    this.customerBuyModel.moarefId = val.id;
                    this.selectedmoaref = val;
                }
            },
            onproductChange(val) {
                if (val && val.id) {
                    console.log(val)
                    this.customerBuyModel.productId = val.id;
                    this.selectedproduct = val;
                }
            },
            onPercentsChange(val) {
                if (val && val.id) {
                    console.log(val)
                    this.buyPercentsModel.percentsId = val.id;
                    this.buyPercentsModel.name = val.name;
                    this.selectedpercents = val;
                    for (let j of this.enpercents) {
                        if (j.value === val.enPercents) {
                            this.buyPercentsModel.enpercentsName = j.title;
                        }
                    }
                }
            },
            onuserDependencyChange(val) {
                if (val && val.id) {
                    console.log(val)
                    this.buyPercentsModel.userId = val.id;
                    this.buyPercentsModel.fullName = val.fullName;
                    this.selectedUserDependency = val;
                }
            },
            addBuyPercent() {
                if (this.buyPercentsModel.percentsId === 0) {
                    Utils.handleErrorWithNotification("لطفا یک مدل درصد انتخاب کنید", this.$noty);
                } else if (this.buyPercentsModel.value === 0) {
                    Utils.handleErrorWithNotification("لطفا مقدار را درصد انتخاب کنید", this.$noty);
                } else if (this.selectedpercents.userDependency && this.selectedUserDependency.id === undefined) {
                    Utils.handleErrorWithNotification("لطفا کاربر را انتخاب کنید", this.$noty);
                } else {
                    this.buyPercentsModel.customerBuyId = this.customerBuyId;
                    if (!this.pSending) {
                        this.pSending = true;
                        new BaseService("BuyPercents", "/CreateBuyPercents").create(this.buyPercentsModel).then(response => {

                            this.pSending = false;
                            this.buyPercents.push(this.buyPercentsModel);
                            this.buyPercentsModel = {
                                percentsId: 0,
                                customerBuyId: 0,
                                userId: 0,
                                value: 0,
                                enpercentsName: "",
                                fullName: "",
                            };
                            this.selectedpercents = {};
                            this.selectedUserDependency = {};
                        }).catch(error => {
                            Utils.handleErrorWithNotification(error.data, this.$noty);
                        });
                    }
                }
            },
            deleteBuyPercentsItem(item, index) {
                if (confirm("آیا از حذف این آیتم اطمینان دارید؟")) {
                    this.buyPercents.splice(index, 1);
                    new BaseService("BuyPercents", "DeletePercents").delete(item.id).then(response => {
                        this.$noty.warning("آیتم با موفقیت حذف شد");
                    }).catch(error => {
                        Utils.handleErrorWithNotification("این آیتم در جای دیگری استفاده شده است، ابتدا موارد وابسته را پاک کنید", this.$noty);
                    })
                }
            },
            onImageChange(e) {
                let files = e.target.files;
                let app = this;
                if (files && files[0]) {
                    this.newImageCliked = true;
                    for (let item of files) {
                        let extension = item.name.slice((item.name.lastIndexOf(".") - 1 >>> 0) + 2);
                        // if (extension === "jpg" || extension === "JPG" ||
                        //     extension === "png" || extension === "PNG" ||
                        //     extension === "JPEG" || extension === "jpeg") {
                        let reader = new FileReader();
                        reader.onload = function (e) {
                            // $("#bannerImg").attr("src", e.target.result);
                            let a = e.target.result;
                            let img = document.getElementById('docImg');
                            img.src = e.target.result;
                            app.customerBuyModel.documents = {
                                address: "",
                                extention: ""
                            };
                            app.customerBuyModel.documents.address = a.substring(a.indexOf(',') + 1, a.length);
                            app.customerBuyModel.documents.extention = extension;
                            app.customerBuyModel.ext = extension;
                            app.customerBuyModel.newImage = e.target.result;
                            console.log(app.customerBuyModel)
                        };
                        reader.readAsDataURL(item);
                        // } else {
                        //     alert("لطفا فایل عکس بارگذاری کنید");
                        // }
                    }
                }
            },
        }
    }
</script>

<style lang="scss" scoped>
    .profile-image {
        margin: 0 auto 1rem auto;
    }

    .profile-image img {
        max-width: 150px;
        border-radius: 1rem;
        box-shadow: 0 10px 25px -10px rgba(0, 0, 0, 0.25);
    }
</style>